<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header">
      {{shareInstance.title}}
    </span>
  </div>
  @if (shareInstance.step === 1) {
    <span
      class="common-modal__content-header-info"
      [afTranslate]="'share-instance.question-title'">
      _¿Con qué finalidad quieres compartir el concepto?
    </span>
  }
  @if (shareInstance.step === 1) {
    <div class="common-modal__form-container-row">
      <button
        (click)="handleAccept('evaluation')"
        [ngClass]="{
          'common-button-card__container--disabled': shareInstance.existingTask
        }"
        [disabled]="shareInstance.existingTask"
        class="common-button-card__container-action">
        <div
          [ngClass]="{
            'common-button-card__title-container-action--disabled': shareInstance.existingTask
          }"
          class="common-button-card__title-container-action">
          <div
            [afTranslate]="'common.evaluation'"
            class="common-button-card__inner-title-action">
            _Evaluación
          </div>
          <i class="lf-icon-task-validate common-icon__xl">
          </i>
        </div>
        <span
          [ngClass]="{
            'common-button-card__description--disabled': shareInstance.existingTask
          }"
          [afTranslate]="'share-instance.option-evaluation'"
          class="common-button-card__description">
          _Crearás una tarea de evaluación asignada a los usuarios o contactos que selecciones.
        </span>
        @if (shareInstance.existingTask && shareInstance.evaluationErrorMessage) {
          <div class="common-status-message__s-container-alert !h-auto w-full">
            <span class="common-status-message__s-title !text-left">
              {{shareInstance.evaluationErrorMessage}}
            </span>
          </div>
        }
      </button>
      <button
        (click)="onQueryShare()"
        class="common-button-card__container-action">
        <div class="common-button-card__title-container-action">
          <div
            [afTranslate]="'share-instance.query'"
            class="common-button-card__inner-title-action">
            _Consulta
          </div>
          <i class="lf-icon-transparency-report common-icon__xl">
          </i>
        </div>
        <span
          [afTranslate]="'share-instance.option-query'"
          class="common-button-card__description">
          _Los contactos seleccionados podrán acceder al concepto en modo lectura.
        </span>
      </button>
    </div>
  }
  @if (shareInstance.step === 2) {
    @if (!shareInstance.queryProduct) {
      <wizard-steps
        [steps]="shareInstance.steps"
        [state]="shareInstance.wizardState">
      </wizard-steps>
    }
    <div class="common-modal__content">
      <span class="common-modal__content-header-info">
        {{shareInstance.shareTitle}}
      </span>
      <div class="common-modal__form-container">
        <div class="common-container__mandatory-obligatory-message-form">
          <span class="common-tag__mandatory-text-asterisk">
            *
          </span>
          <span
            [afTranslate]="'common.required-fields'"
            class="common-tag__mandatory-label-text-obligatory-message">
            _Campos obligatorios
          </span>
        </div>
        <form class="common-modal__content">
          @switch (shareInstance.wizardState) {
            @case (1) {
              <field-type-contacts
                class="w-full"
                [field]="shareInstance.shareInstanceContact"
                [concept]="concept"
                (sendContacts)="receiveContacts($event.contacts)"
                (contactsClosed)="contactsClosed()">
              </field-type-contacts>
              @if (shareInstance.showText) {
                <field-type-rich-text-editable
                  class="w-full"
                  [field]="shareInstance.fieldRich"
                  [preSelectItem]="shareInstance.message"
                  (itemSelected)="shareInstance.message = $event.newValue">
                </field-type-rich-text-editable>
              }
            }
            @default {
              <field-type-list-extended
                class="w-full"
                [field]="shareInstance.shareTypeDocumentField"
                [listValues]="shareInstance.typeShareDocument"
                [preSelectItem]="shareInstance.typeShareDocumentSelected"
                (itemSelected)="shareInstance.typeShareDocumentSelected = $event.newValue">
              </field-type-list-extended>
              @if (shareInstance.typeShareDocumentSelected==='2') {
                <field-type-list-multiple
                  class="w-full"
                  [field]="shareInstance.shareDocumentationField"
                  [listValues]="shareInstance.shareDocumentationList"
                  [preSelectItem]="shareInstance.shareDocumentationListSelected"
                  (itemSelected)="selectSharedDocumentation($event)">
                </field-type-list-multiple>
              }
            }
          }
        </form>
      </div>
    </div>
  }
  <div class="common-modal__footer">
    @if (shareInstance.step === 1) {
      <button
        (click)="handleDismiss()"
        class="common-button__text">
        <span
          [afTranslate]="'common.close'"
          class="common-button__text-title">
        </span>
      </button>
    }
    @if (shareInstance.step === 2) {
      <button
        [ngClass]="{
          'common-button__text-border': shareInstance.wizardState === 1,
          'common-button__text-noborder': shareInstance.wizardState === 2
        }"
        (click)="handleDismiss()">
        <span
          [afTranslate]="'common.cancel'"
          class="common-button__text-title">
          _Cancelar
        </span>
      </button>
      @if (shareInstance.wizardState === 1) {
        @if (from === 'knowledge') {
          <button
            (click)="validateKnowledge()"
            class="common-button__text">
            <span
              [afTranslate]="'common.share'"
              class="common-button__text-title">
              _Compartir
            </span>
          </button>
        }
        @else {
          <button
            (click)="nextStep()"
            class="common-button__text">
            <span
              [afTranslate]="'common.next'"
              class="common-button__text-title">
              _Siguiente
            </span>
          </button>
        }
      }
      @else {
        <button
          class="common-button__text-border"
          (click)="backStep()">
          <span
            [afTranslate]="'common.previous'"
            class="common-button__text-title">
            _Anterior
          </span>
        </button>
        <button
          (click)="checkOptions()"
          class="common-button__text">
          <span
            [afTranslate]="'common.share'"
            class="common-button__text-title">
            _Compartir
          </span>
        </button>
      }
    }
  </div>
</div>
